import React, { Component } from 'react';
import styled from 'styled-components';

import ProgressStep from './ProgressStep';

const ProgressStepsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1rem 1rem;
`;

class ProgressSteps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: props.step,
      totalSteps: props.steps.totalSteps
    }
  };

  render() {


    const steps = [];
    for (let step = 1; step < this.state.totalSteps + 1; step++) {
      let allowSpacer = true;
      if (step === this.state.totalSteps) {
        allowSpacer = false;
      }
      if (step <= this.props.step) {
        steps.push(<ProgressStep key={step} active step={step} allowSpacer={allowSpacer} steps={this.props.steps}/>);
      } else {
        steps.push(<ProgressStep key={step} step={step} allowSpacer={allowSpacer} steps={this.props.steps}/>);
      }
    }

    // console.log('prog steps', this.props.step);

    return (
        <ProgressStepsWrapper>
          {this.state.step >= 1 ? steps : null}
        </ProgressStepsWrapper>
    );
  };
};

export default ProgressSteps;



// WEBPACK FOOTER //
// ./src/components/ProgressSteps/ProgressSteps.js